import { FC } from 'react';
import { useLoginModal } from './useLoginModal';
import BrokersList from './BrokersList';
import classNames from 'classnames';
import UserValidaition from './UserValidaition';
import { useResponsive } from 'v3/common/hooks/useResponsive';
import { useLoginContext } from './LoginProvider';
import { ACTIVE_BROKERS_DOMAINS } from '../../types.type';
import { Nullable } from './types.type';

type LoginModalProps = {
  goToCredentialPhase: boolean;
  hideLoginModal: () => void;
  preSelectedBrokerId: Nullable<ACTIVE_BROKERS_DOMAINS>;
};

const LoginModal: FC<LoginModalProps> = ({
  goToCredentialPhase = false,
  hideLoginModal,
  preSelectedBrokerId,
}) => {
  // Login Modal Hooks Run
  useLoginModal(goToCredentialPhase, hideLoginModal, preSelectedBrokerId);
  // Responsive Hook
  const isMobile = useResponsive();
  // Login Provider Hooks
  const {
    state: { currentPageIndex },
    switchPage,
  } = useLoginContext();

  const toggleModal = () => {
    switch (currentPageIndex) {
      case 1:
      case 2:
        return <UserValidaition />;
      default:
        return <BrokersList />;
    }
  };

  const combinedClassName = classNames('login-modal__content', {
    mobile: isMobile,
    'page-1': currentPageIndex === 0,
    'page-2': currentPageIndex === 1,
    'page-3': currentPageIndex === 2,
  });

  const shouldDisableBackButtonOnDomainLogin = goToCredentialPhase && currentPageIndex !== 2;

  return (
    <div className={combinedClassName}>
      {/* this is displayed on mobile */}
      <div className="mobile-top-bar">
        {currentPageIndex !== 0 && !shouldDisableBackButtonOnDomainLogin && (
          <button className="back-btn" onClick={() => switchPage(false)}>
            <i className="fa-regular fa-chevron-left" />
            <span className="ms-2">Back</span>
          </button>
        )}
        <div className="close-btn" onClick={() => hideLoginModal()}>
          <i className="fa-regular fa-xmark" />
        </div>
      </div>
      {/* this is displayed on web */}
      {/* 3rd page doesnt have the close button */}
      {!(currentPageIndex === 2) && (
        <div className="close-btn" onClick={hideLoginModal}>
          <i className="fa-regular fa-xmark" />
        </div>
      )}
      {currentPageIndex !== 0 && !isMobile && !shouldDisableBackButtonOnDomainLogin && (
        <button className="back-btn" onClick={() => switchPage(false)}>
          <i className="fa-regular fa-chevron-left" />
          <span className="ms-2">Back</span>
        </button>
      )}
      {/* Header is Mandatory the classname is used for html insertion using ReactPortal */}
      {/* Refer to the PortalToTarget component for implementation details */}
      <div className="login-modal__header" />
      <div className="login-modal__divider">
        <hr />
      </div>
      <div className="login-modal__body">{toggleModal()}</div>
      {/* Footer is Mandatory do not remove this div */}
      <div className="login-modal__footer" />
    </div>
  );
};

export default LoginModal;
